import Tooltip from "@components/Starmap/Tooltip";
import usePlanetSelect from "@hooks/Starmap/usePlanetSelect";
import IPlanet from "@interfaces/Starmap/Planet";
import { createLinkName } from "@scripts/StringsHelper";
import STARS from "../../../../../starmap.stars.data";
import styles from "./FirstOrder.module.scss";

interface IFirstOrderProps {
    stars: IPlanet[] | undefined;
}

const FirstOrder = ({ stars }: IFirstOrderProps): JSX.Element => {
    const { handleChangeLinkColor, handleLeaveLinkColor } = usePlanetSelect({ stars });

    return (
        <div className={styles.firstOrder__container}>
            <div className={styles.heading}>
                <h2>1ST ORDER</h2>
                <hr /> <p>(Orbits Sun)</p>
            </div>
            <div className={styles.grid}>
                {stars?.map(({ id, name, world_type }) => (
                    <>
                        <Tooltip id={`star-tooltip-${id}`} />
                        <a
                            id={`star-item-${id}`}
                            data-tooltip-id={`star-tooltip-${id}`}
                            data-tooltip-html={`<div><h3>${name}</h3></div>`}
                            onMouseOver={() => handleChangeLinkColor(id)}
                            onMouseLeave={() => handleLeaveLinkColor()}
                            key={id}
                            className={styles.grid__item}
                            href={createLinkName(name)}
                        >
                            <img src={STARS[world_type]} alt={name} />
                        </a>
                    </>
                ))}
            </div>
        </div>
    );
};

export default FirstOrder;
